import {
  BaseSyntheticEvent,
  MouseEvent,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

import { MenuItem } from 'libs/ui';
import { renderToStaticMarkup } from 'react-dom/server';

import { OverflowTabsProps } from './types';

export const useOverflowTabs = ({
  tabs,
  onChange,
}: Pick<OverflowTabsProps, 'tabs' | 'onChange'>) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [visibleTabs, setVisibleTabs] = useState(tabs);
  const [overflowTabs, setOverflowTabs] = useState<typeof tabs>([]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const onClickMenuOption = (
    item: MenuItem<string>,
    event: MouseEvent<HTMLElement>
  ) => {
    onChange?.(event, item.value);
    handleCloseMenu();
  };

  const onBurgerEvent = (event: BaseSyntheticEvent) => {
    setAnchorEl(event.currentTarget);
  };

  useLayoutEffect(() => {
    const recalcTabs = () => {
      const container = containerRef.current;
      if (!container) return;

      const containerWidth = container.offsetWidth;
      let totalWidth = 0;
      const newVisible = [];
      const newOverflow = [];

      for (const tab of tabs) {
        const fake = document.createElement('span');
        fake.style.visibility = 'hidden';
        fake.style.position = 'absolute';
        fake.style.whiteSpace = 'nowrap';
        if (typeof tab.label === 'string') {
          fake.innerHTML = tab.label;
        } else if (tab.label && typeof tab.label === 'object') {
          fake.innerHTML = renderToStaticMarkup(
            tab.label as React.ReactElement
          );
        } else {
          fake.innerHTML = '';
        }
        container.appendChild(fake);
        const width = fake.offsetWidth + 32;
        container.removeChild(fake);

        if (totalWidth + width < containerWidth - 50) {
          totalWidth += width;
          newVisible.push(tab);
        } else {
          totalWidth += width;
          newOverflow.push(tab);
        }
      }

      setVisibleTabs(newVisible);
      setOverflowTabs(newOverflow);
    };

    recalcTabs();

    window.addEventListener('resize', recalcTabs);
    return () => {
      window.removeEventListener('resize', recalcTabs);
    };
  }, [tabs]);

  return {
    containerRef,
    visibleTabs,
    overflowTabs,
    anchorEl,
    isMenuOpen,
    handleCloseMenu,
    onClickMenuOption,
    onBurgerEvent,
  };
};
